const dellMetricsTrackProp20 = (appcode, tabname) => {
    try {
        if (typeof (window.dellmetricsTrack) === "function") {
            if (window.dellmetricsTrack) {
                window.dellmetricsTrack(appcode, tabname);
            }
        }
    } catch (ex) {
        console.error(`${ex}`);
    }
}

const linkCreateAccount = document.getElementById('creatacclink');

const signInBtn = document.getElementById('signInBtn');

const visitBusinessLink = document.getElementById('businessvisitlink');

if (linkCreateAccount != null) {
    linkCreateAccount.addEventListener("click", function () {
        dellMetricsTrackProp20('222.900.200.100', 'createanaccount');
    });
}

if (signInBtn != null) {
    signInBtn.addEventListener("click", function () {
        dellMetricsTrackProp20('222.900.100.250', 'signin');
    });
}

if (visitBusinessLink != null) {
    visitBusinessLink.addEventListener("click", function () {
        dellMetricsTrackProp20('222.900.200.101', 'visitbusinesssite');
    });
}

document.querySelectorAll('.metricslinks').forEach((item) => {
    item.addEventListener('click',
        function() {
        var appCode = '222.900.200.153', pev2 = '';
        if (this.dataset.tilename === 'ManageFleet')
        {
            pev2 = 'managefleet';
        }
        if (this.dataset.tilename === 'CreateDispatch')
        {
            pev2 = 'createdispatch';
        }
        if (this.dataset.tilename === 'FindDrivers')
        {
            pev2 = 'finddrivers';
        }
        if (this.dataset.tilename === 'GenerateProcedures')
        {
            pev2 = 'generateprocedures';
        }
        dellMetricsTrackProp20(appCode, pev2);
    });
});

export {
    dellMetricsTrackProp20
}